import Image from "next/image";
import Title from "./Title";
import Subtitle from "./Subtitle";
import Link from "next/link";
import { Play } from "lucide-react";

export default function NewsCard({
  title,
  subtitle,
  imageUrl,
  imageAlt = "News image",
  showDot = false,
  dotColor = "bg-orange-500",
  className = "",
  titleClassName = "",
  subtitleClassName = "",
  imageClassName = "",
  href,
  titleAs = "h2",
  subtitleAs = "h3",
  isVideo = false,
  loading = "lazy",
  fetchPriority = "low",
  decoding = "async",
}) {
  const CardWrapper = href ? Link : "div";

  return (
    <div className={`bg-white ${className}`}>
      {/* Title with optional dot */}
      <div className="mb-5">
        <Title
          as={titleAs}
          className={titleClassName}
          showDot={showDot}
          dotColor={dotColor}
        >
          {title}
        </Title>
      </div>

      <CardWrapper
        href={href}
        className={`block bg-white cursor-pointer ${className}`}
      >
        {/* Subtitle */}
        <Subtitle
          className={`mb-2 ${subtitleClassName}`}
          subtitleAs={subtitleAs}
        >
          {subtitle}
        </Subtitle>

        {/* Image */}
        {imageUrl && (
          <div
            className={`relative w-full rounded-lg overflow-hidden ${imageClassName}`}
          >
            <Image
              src={imageUrl}
              alt={imageAlt}
              sizes="(max-width:768px) 100vw, 50vw"
              loading={loading}
              fetchPriority={fetchPriority}
              decoding={decoding}
              width="1200"
              height="800"
              className="absolute inset-0  object-cover"
            />

            {/* Video Play Button Overlay */}
            {isVideo && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div
                  className="w-[60px] h-[60px] 
              bg-black/60 
              rounded-full 
              flex items-center justify-center"
                >
                  <Play className="w-8 h-8 text-white fill-white stroke-none" />
                </div>
              </div>
            )}
          </div>
        )}
      </CardWrapper>
    </div>
  );
}
